import { BrowserRouter, Routes, Route } from 'react-router';
import { Layout } from './pages/Layout';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { Portfolio } from './pages/Portfolio';
import { Testimonials } from './pages/Testimonials';
import { Contact } from './pages/Contact';
import { AdminLogin } from './pages/AdminLogin';
import { AdminDashboard } from './pages/AdminDashboard';
import { CustomPage } from './pages/CustomPage';
import { SiteConfigProvider } from './utils/siteConfig';
import { ScrollToTop } from './components/ScrollToTop';

export default function App() {
  const rawBase = import.meta.env.BASE_URL || '/';
  let routerBasename = rawBase === '/' ? '' : rawBase.replace(/\/$/, '');

  // If we are in dev mode but the user explicitly navigated to the production path,
  // adapt the basename so React Router doesn't throw a "No routes matched" error.
  if (import.meta.env.DEV && window.location.pathname.startsWith('/biggrow/dist')) {
    routerBasename = '/biggrow/dist';
  }

  return (
    <SiteConfigProvider>
      <BrowserRouter basename={routerBasename}>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="services" element={<Services />} />
            <Route path="portfolio" element={<Portfolio />} />
            <Route path="testimonials" element={<Testimonials />} />
            <Route path="contact" element={<Contact />} />
            <Route path="page/:slug" element={<CustomPage />} />
          </Route>
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </SiteConfigProvider>
  );
}
